export default {
  'DownloadFileRow.RightSide.View': ({ }, outlet) => {
    outlet({ action: 'view' })
  },
  'DownloadFileRow.RightSide.Download': ({ }, outlet) => {
    outlet({ action: 'download' });
  },

}